import React, { useState, KeyboardEvent } from 'react';

interface SearchInputProps {
  onSubmit: (question: string) => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({ onSubmit, onCancel, isLoading }) => {
  const [question, setQuestion] = useState('');

  const handleSubmit = () => {
    if (question.trim() && !isLoading) {
      onSubmit(question.trim());
      setQuestion('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="search-input-container">
      <div className="search-input-wrapper">
        <textarea
          className="search-textarea"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="输入你想研究的问题..."
          disabled={isLoading}
          rows={1}
        />
        {isLoading ? (
          <button
            className="search-button search-button-stop"
            onClick={onCancel}
            title="停止研究"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <rect x="4" y="4" width="16" height="16" rx="2" />
            </svg>
          </button>
        ) : (
          <button
            className="search-button"
            onClick={handleSubmit}
            disabled={!question.trim()}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
